const ChannelsName = {
  Blipchat: 'Blip Chat',
  Messenger: 'Messenger',
  Instagram: 'Instagram',
  Whatsapp: 'WhatsApp',
};

export default ChannelsName;
